import React from 'react';
import { IoMdClose } from 'react-icons/io';
import { FaBox, FaStore, FaMoneyBillWave, FaPercent } from 'react-icons/fa';

const OrderFullDetails = ({ order, toggle }) => {
    const hasDeletedProducts = order?.order_items?.some(item => 
        !item.product_name || item.product_name === 'Product Not Found'
    );
    
    return (
        <div className='bg-gray-100 rounded-lg shadow-md'>
            <div className="flex justify-between items-center px-3 py-2 border-b">
                <h2 className="text-base font-semibold text-gray-800">Order Details</h2>
                <IoMdClose 
                    size={18} 
                    onClick={toggle} 
                    className='hover:scale-105 hover:text-red-800 transition duration-150 ease-out cursor-pointer text-gray-500' 
                />
            </div>

            <div className="max-w-2xl mx-auto px-3 py-4 max-h-[70vh] overflow-auto">
                <div className="bg-white rounded-lg p-3 mb-4 shadow-sm">
                    <div className="flex items-center gap-2 mb-2">
                        <FaStore className="text-gray-400 w-4 h-4" />
                        <h3 className="text-sm">Retailer: <span className='font-semibold text-gray-800'>{order?.retailer?.name || 'No retailer'}</span></h3>
                    </div>
                    <div className="grid grid-cols-2 gap-3">
                        <div className="flex items-center gap-2">
                            <FaBox className="text-gray-400 w-4 h-4" />
                            <p className="text-sm">Status: <span className='font-semibold text-gray-800'>{order?.status}</span></p>
                        </div>
                        <div className="flex items-center gap-2">
                            <FaPercent className="text-gray-400 w-4 h-4" />
                            <p className="text-sm">Discount: <span className='font-semibold text-gray-800'>{order?.discount || '0'}</span></p>
                        </div>
                        <div className="flex items-center gap-2">
                            <FaMoneyBillWave className="text-gray-400 w-4 h-4" />
                            <p className="text-sm">Total: <span className='font-semibold text-gray-800'>{order?.invoice_total || '0'}</span></p>
                        </div>
                    </div>
                </div>

                <div className="bg-white rounded-lg p-3 shadow-sm">
                    <h3 className="text-sm font-semibold mb-3 flex items-center gap-2">
                        <FaBox className="text-gray-400 w-4 h-4" />
                        Cart Items
                    </h3>
                    {hasDeletedProducts ? (
                        <div className="text-center py-4">
                            <FaBox className="text-gray-400 w-8 h-8 mx-auto mb-2" />
                            <p className="text-gray-600 font-medium">No products found</p>
                            <p className="text-gray-500 text-xs mt-1">Some products in this order have been deleted</p>
                        </div>
                    ) : (
                    <table className="w-full">
                        <thead>
                                <tr className="border-b text-sm bg-gray-50">
                                    <th className="text-left py-2 px-3">#</th>
                                    <th className="text-left py-2 px-3">Product Name</th>
                                    <th className="text-left py-2 px-3">Manufacturer</th>
                                    <th className="text-right py-2 px-3">Quantity</th>
                            </tr>
                        </thead>
                            <tbody className='text-sm'>
                            {order?.order_items?.map((item, index) => (
                                    <tr key={item?.id} className="border-b hover:bg-gray-50">
                                        <td className="py-2 px-3">{index + 1}.</td>
                                        <td className="py-2 px-3 font-medium">{item?.product_name}</td>
                                        <td className="py-2 px-3 text-gray-600">{item?.manufacturer}</td>
                                        <td className="py-2 px-3 text-right font-medium">{item?.demand_quantity}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    )}
                </div>
            </div>
        </div>
    );
}

export default OrderFullDetails;
